import { gql } from "@apollo/client";

export const GET_PATIENT_CONDITIONS_BY_PATIENT_ID = gql`
  query PatientConditionsByPatientId($patient_id: ID!) {
    patientConditionsByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      date
      conditions
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATIENT_CONDITION_BY_ID = gql`
  query PatientConditionById($id: ID!) {
    patientConditionById(_id: $id) {
      _id
      patient_id
      date
      conditions
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATIENT_CONDITIONS_BY_IDS = gql`
  query PatientConditionsByIds($ids: [ID!]!) {
    patientConditionsByIds(ids: $ids) {
      _id
      patient_id
      date
      conditions
      createdAt
      updatedAt
    }
  }
`;
